module.exports = __webpack_public_path__ + "img/AboutMetadata.fdc2db3e.png";